import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _MdLightCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "M17.285 17h-3.142V6.818h3.28q1.483 0 2.536.612a4 4 0 0 1 1.616 1.745q.562 1.133.562 2.714 0 1.59-.567 2.74a4.04 4.04 0 0 1-1.65 1.76q-1.084.61-2.635.611m-1.91-1.094h1.83q1.263 0 2.093-.487a3 3 0 0 0 1.238-1.387q.408-.9.408-2.143 0-1.233-.403-2.123a2.97 2.97 0 0 0-1.203-1.372q-.8-.482-1.994-.482h-1.969zM1.688 6.818h1.471l3.46 8.452h.12l3.46-8.452h1.472V17h-1.154V9.264h-.1L7.237 17H6.122L2.94 9.264h-.1V17H1.689z" })));
}
const MdLightCustom = forwardRef(_MdLightCustom);
export { MdLightCustom };
